import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";
import {IGalleryPeopleItem} from "../types/GalleryPeopleItem";

type stateType = {
    fetched: boolean;
    loading: boolean;
    items: IGalleryPeopleItem[] | null;
}

const initialState: stateType = {
    fetched: false,
    loading: false,
    items: null,
}
export const fetchGalleryPeople = createAsyncThunk('gallery/fetchGalleryPeople', () => {
    return axios
        .get(`https://php.motokarymartin.sk/gallery-people/?location=${config.location}`)
        .then((response) => response.data);
});

const galleryPeopleSlice = createSlice({
    name: 'galleryPeople',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchGalleryPeople.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(fetchGalleryPeople.fulfilled, (state, action) => {
            state.fetched = true;
            state.loading = false;
            state.items = action.payload;
        })
        builder.addCase(fetchGalleryPeople.rejected, (state, action) => {
            state.loading = false;
            console.error("During fetching of gallery people there was an error:", action.error);
        })
    },
});

export default galleryPeopleSlice.reducer;